import React from "react";
import { StyledMarkdown } from "./TextMarkup.styles";
import { SxProps } from "@mui/material";

export function TextMarkup({
    textToMarkup = "",
    sx,
}: {
    textToMarkup: string;
    sx?: SxProps;
}) {
    return <StyledMarkdown sx={sx}>{textToMarkup}</StyledMarkdown>;
}
